var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none",
  viewBox: "0 0 17 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2B87B1",
  d: "m8.99.971-1.41 1.41 5.58 5.59H.99v2h12.17l-5.58 5.59 1.41 1.41 8-8z"
})));
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguOTg5MjYgMC45NzExOTFMNy41NzkyNiAyLjM4MTE5TDEzLjE1OTMgNy45NzExOUgwLjk4OTI1OFY5Ljk3MTE5SDEzLjE1OTNMNy41NzkyNiAxNS41NjEyTDguOTg5MjYgMTYuOTcxMkwxNi45ODkzIDguOTcxMTlMOC45ODkyNiAwLjk3MTE5MVoiIGZpbGw9IiMyQjg3QjEiLz4KPC9zdmc+Cg==";